import React, { createContext, PropsWithChildren, useContext, useRef, useState } from 'react';

import { VaultId } from 'backend-client-web';

import { ReactSetter } from 'src/util/types';

type LoginVaultViewDataContextValue = {
  bulkEditMode: boolean;
  setBulkEditMode: ReactSetter<boolean>;
  prevVaultIdRef: React.MutableRefObject<VaultId | undefined>;
};

const LoginVaultViewDataContext = createContext<LoginVaultViewDataContextValue>({
  bulkEditMode: false,
  setBulkEditMode: () => undefined,
  prevVaultIdRef: { current: undefined },
});

export function LoginVaultViewDataContextProvider({ children }: PropsWithChildren<{}>) {
  const prevVaultIdRef = useRef<VaultId>();
  const [bulkEditMode, setBulkEditMode] = useState(false);
  return (
    <LoginVaultViewDataContext.Provider value={{ bulkEditMode, setBulkEditMode, prevVaultIdRef }}>
      {children}
    </LoginVaultViewDataContext.Provider>
  );
}

export function useLoginVaultViewDataContext() {
  return useContext(LoginVaultViewDataContext);
}
